import React from 'react';
import axios from "axios";
import { formatCurrency } from "../../functions/numbers";
import { url, API_Dashboard } from "../../apis/constant";
import Datatable from "../datatable";

const OrderProfitability = ({orderProfitabilityStatus, startDate,endDate}) => {
  const [apiData, setApiData] = React.useState([]);

  // Define your columns for the datatable here
  const columns = [
    {
      Header: "Order No",
      accessor: "orderId",
    },
    {
      Header: "Vendor Name",
      accessor: "vendorName",
    },
    {
      Header: "Vendor ID",
      accessor: "vendorId",
    },
    {
      Header: "Total",
      accessor: "totalAmount",
    },
    {
      Header: "Comm Revenue",
      accessor: "commission",
    },
    {
      Header: "User Referral",
      accessor: "userReferral",
    },
    {
      Header: "Vendor Referral",
      accessor: "vendorReferral",
    },
    {
      Header: "Customer Rewards",
      accessor: "customerRewards",
    },
    {
      Header: "Other Charges eg Bank Txn",
      accessor: "otherCharge",
    },
    {
      Header: "Gross Margin",
      accessor: "grossMargin",
    },

  ];

  React.useEffect(() => {
    const adminToken = localStorage.getItem("wed_admin_token");
    try {
      axios.get(url + API_Dashboard.orderProfitability, { // Replace with the correct endpoint
        params: {status: orderProfitabilityStatus, startDate, endDate},
        headers: {
          Authorization: `Bearer ${adminToken}`
        }
      }).then(res => {
        setApiData(res.data.data);
      }).catch(err => {
        console.log(err);
      })
    } catch (error) {
      console.log(error);
    }
  }, [orderProfitabilityStatus, startDate, endDate]);

  return (
    <div className="p-2 bg-white border rounded-md text-xl table-responsive">
      <Datatable columns={columns}
        data={apiData.map((item) => ({
          ...item,
          totalAmount: formatCurrency(item.totalAmount),
          commission: formatCurrency(item.commission),
          userReferral: formatCurrency(item.userReferral),
          vendorReferral: formatCurrency(item.vendorReferral),
          customerRewards: formatCurrency(item.customerRewards),
          otherCharge: formatCurrency(item.otherCharge),
          grossMargin: (item.grossMargin * 100) + " %"
        }))}
        showResponseData={false}
        showSelection={false}
      />
    </div>
  );
}

export default OrderProfitability;
